import { useEffect, useState } from "react";
import { Cookie, X } from "lucide-react";
import { Link } from "react-router-dom";

const STORAGE_KEY = "barbearia18:cookie-consent:v1";

export const CookieBanner = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        try {
            const v = localStorage.getItem(STORAGE_KEY);
            if (!v) setVisible(true);
        } catch {
            // localStorage unavailable; keep banner hidden
        }
    }, []);

    const accept = () => {
        try {
            localStorage.setItem(
                STORAGE_KEY,
                JSON.stringify({
                    accepted: true,
                    at: new Date().toISOString(),
                }),
            );
        } catch {
            /* ignore */
        }
        setVisible(false);
    };

    const dismiss = () => {
        try {
            localStorage.setItem(
                STORAGE_KEY,
                JSON.stringify({
                    accepted: false,
                    at: new Date().toISOString(),
                }),
            );
        } catch {
            /* ignore */
        }
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div
            data-testid="cookie-banner"
            className="fixed bottom-4 left-4 right-4 md:left-6 md:right-auto md:bottom-6 md:max-w-md z-[90] bg-[#121212] border border-[#262626] shadow-2xl p-5 md:p-6"
        >
            <div className="flex items-start gap-4">
                <div className="text-[#d4af37] shrink-0 pt-0.5">
                    <Cookie size={20} />
                </div>
                <div className="flex-1">
                    <div className="text-xs tracking-widest uppercase text-[#737373] mb-2">
                        Privacidade
                    </div>
                    <p className="text-sm text-[#f5f5f0] leading-relaxed mb-4">
                        Este site usa apenas cookies essenciais ao
                        funcionamento. Não recolhemos dados para publicidade
                        nem partilhamos com terceiros.{" "}
                        <Link
                            to="/cookies"
                            className="text-[#d4af37] hover:underline"
                            data-testid="cookie-banner-link"
                        >
                            Saber mais
                        </Link>
                        .
                    </p>
                    <div className="flex flex-col sm:flex-row gap-2">
                        <button
                            onClick={accept}
                            data-testid="cookie-accept-btn"
                            className="px-5 py-3 bg-[#d4af37] text-[#0a0a0a] text-xs tracking-wide uppercase font-semibold hover:bg-[#b3912e] transition-colors rounded-sm min-h-[44px]"
                        >
                            Aceitar
                        </button>
                        <button
                            onClick={dismiss}
                            data-testid="cookie-dismiss-btn"
                            className="px-5 py-3 border border-[#262626] text-[#a3a3a3] text-xs tracking-wide uppercase hover:text-[#f5f5f0] hover:border-[#3a3a3a] transition-colors rounded-sm min-h-[44px]"
                        >
                            Recusar
                        </button>
                    </div>
                </div>
                <button
                    onClick={dismiss}
                    aria-label="Fechar"
                    data-testid="cookie-close-btn"
                    className="text-[#737373] hover:text-[#f5f5f0] transition-colors p-2 -m-2 shrink-0"
                >
                    <X size={20} />
                </button>
            </div>
        </div>
    );
};
